<template>
  <div class="app-pro-consulta" ref="dados">
    <div class="app-pro--dados" ref="dados">
      <table>
        <tr>  
          <td :colspan="(cpntMostrarEstoque === true ? 3 : 2) + (cpntMostrarEstoqueSincronizado === true ? 1 : 0)" style="text-align: left; font-size: 16px; font-weight: bold; opacity: 0.85; height: 40px;">
            <template v-if="[ '', null, undefined ].indexOf(cpntNome) !== -1">
              <span>&nbsp;</span>
            </template>
            <template v-else>
              <!-- SETA O NOME DO PRODUTO -->
              <span v-html="cpntNome"></span>

              <!-- SETA OS BOTOTES PARA O PRODUTO -->
              <span v-if="$store.state.token.pdv === false" class="acoes">
                <!-- SETA O BOTÃO EDITAR -->
                <App-Button :cpntClass="'btn btn-warning btn-sm'" @onClick="() => { cpntAcaoProdutoEditar('', cpntId) }" :cpntIcone="'editar'" :title="'Editar'"></App-Button>

                <!-- SETA O BOTÃO HISTORICO -->
                <App-Button :cpntClass="'btn btn-info btn-sm'" @onClick="() => { cpntAcaoProdutoHistorico() }" :cpntIcone="'historico'" :title="'Histórico'"></App-Button>
              </span>
            </template>
          </td>
        </tr>

        <tr :class="'qtde-col--' + ((cpntMostrarEstoque === true ? 3 : 2) + (cpntMostrarEstoqueSincronizado === true ? 1 : 0))">  
          <td>
            <div class="quadrado">
              <div class="titulo">
                Unidade
              </div>

              <div class="conteudo">
                <div>
                  <template v-if="[ '', null, undefined ].indexOf(cpntUnidade) !== -1">
                    <span>---</span>
                  </template>
                  <template v-else>
                    <!-- SETA O ID UNIDADE -->
                    <span v-html="cpntUnidade"></span>

                    <!-- SETA O SEPARADOR -->
                    <span> - </span>

                    <!-- SETA O O NOME DA UNIDADE -->
                    <span v-html="cpntUnidadeDescricao"></span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="quadrado">
              <div class="titulo">
                Valor Unitário (R$)
              </div>

              <div class="conteudo">
                <div :style="[ '3126', '3154', '3155', '9122', '9123', '9124' ].indexOf($store.state.token.clu) !== -1 ? 'font-weight: bold;' : ''">
                  <template v-if="[ '', null, undefined ].indexOf(cpntValorVen) !== -1">
                    <span>---</span>
                  </template>
                  <template v-else>
                    <!-- SETA A SIGLA DA MOEDA -->
                    <span>R$ </span>

                    <!-- SETA O VALOR DE VENDA DO PRODUTO -->
                    <span v-html="proConConFormatarValor()"></span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <td v-if="cpntMostrarEstoque === true">
            <div class="quadrado">
              <div class="titulo">
                Qtde em Estoque
              </div>

              <div class="conteudo">
                <div>
                  <template v-if="[ '', null, undefined ].indexOf(cpntEstoque) !== -1 || [ '', null, undefined ].indexOf(cpntEstoque.estoque) !== -1">
                    <span>---</span>
                  </template>
                  <template v-else>
                    <span :style="cpntEstoque.estoque.indexOf('-') !== -1 ? 'color: red;' : ''" v-html="cpntEstoque.estoque"></span>
                  </template>
                </div>
              </div>
            </div>
          </td>

          <td v-if="cpntMostrarEstoqueSincronizado === true">
            <div class="quadrado">
              <div class="titulo">
                Qtde. Total Estoque Lojas
              </div>

              <div class="conteudo">
                <div>
                  <template v-if="[ '', null, undefined ].indexOf(cpntEstoqueSincronizado) !== -1 || [ '', null, undefined ].indexOf(cpntEstoqueSincronizado.estoque) !== -1">
                    <span>---</span>
                  </template>
                  <template v-else>
                    <span :style="cpntEstoqueSincronizado.estoque.indexOf('-') !== -1 ? 'color: red;' : ''" v-html="cpntEstoqueSincronizado.estoque"></span>
                  </template>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style scoped>
  .app-pro--dados {
    width: calc(100% + 7px);
    /* margin-top: 15px; */
    /* margin-bottom: 15px; */
  }
    .app-pro--dados > table {
      width: calc(100% - 10px);
      /* width: 100%; */
    }
      .app-pro--dados > table > tr > td {
        vertical-align: top;
        padding: 15px 5px 0px 5px;
      }
      .app-pro--dados > table > .qtde-col--2 > td {
        width: calc(100% / 2);
      }
      .app-pro--dados > table > .qtde-col--3 > td {
        width: calc(100% / 3);
      }
      .app-pro--dados > table > .qtde-col--4 > td {
        width: calc(100% / 4);
      }
        .app-pro--dados > table > tr > td > .quadrado {
          border: 1px solid #ccc;
          border-radius: 3px;
        }
          .app-pro--dados > table > tr > td > .quadrado > .titulo {
            background: #e9e9e9;
            border-bottom: 1px solid #ccc;
            font-weight: bold;
            text-align: center;
            opacity: 0.8;
          }
          .app-pro--dados > table > tr > td > .quadrado > .conteudo {
            text-align: center;
            vertical-align: middle;
          }
            .app-pro--dados > table > tr > td > .quadrado > .conteudo > div {
              display: table-cell;
              vertical-align: middle;
              height: 60px;
              text-align: center;
            }

            .app-pro--dados > table > .qtde-col--2 > td > .quadrado > .conteudo,
            .app-pro--dados > table > .qtde-col--2 > td > .quadrado > .conteudo > div {
              width: 323px;
            }
            .app-pro--dados > table > .qtde-col--3 > td > .quadrado > .conteudo,
            .app-pro--dados > table > .qtde-col--3 > td > .quadrado > .conteudo > div {
              width: 210px;
            }
            .app-pro--dados > table > .qtde-col--4 > td > .quadrado > .conteudo,
            .app-pro--dados > table > .qtde-col--4 > td > .quadrado > .conteudo > div {
              width: 154px;
            }

            .app-pro--dados > table > tr > td:not(:first-child) > .quadrado > .conteudo > div {
              font-size: 17px;
            }

      .app-pro--dados > table > tr > td > .acoes {
        text-align: center;
      }
        .app-pro--dados > table > tr > td > .acoes > button {
          width: 25px;
          height: 20px;
          margin: 0px 3px;
          padding: 0px;
        }
</style>

<script>
export default {
  props: {
    cpntId: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntNome: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntIdCat: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntUnidade: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntUnidadeDescricao: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntValorVen: {
      required: true,
      type: String,
      default: function () {
        return ''
      }
    },
    cpntMostrarEstoque: {
      required: true,
      type: Boolean,
      default: function () {
        return false
      }
    },
    cpntMostrarEstoqueSincronizado: {
      required: true,
      type: Boolean,
      default: function () {
        return false
      }
    },
    cpntEstoque: {
      required: true
    },
    cpntEstoqueSincronizado: {
      required: true
    },
    cpntAcaoProdutoEditar: {
      required: true
    },
    cpntAcaoProdutoHistorico: {
      required: true
    }
  },
  methods: {
    proConConFormatarValor: function () {
      return this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', this.cpntValorVen)
    }
  }
}
</script>
